import React from 'react'
import { Modal } from 'react-bootstrap'
import { getTokenSymbol, formatSmartDecimal, handleToFixedOnDecimals, getBackgroundColor, hexToRgb } from '../../utils/helpers'
import { useTranslation } from 'react-i18next'
import { useTheme } from '../../contexts/ThemeProvider'
import { useSwipeClose } from '../../hooks/useSwipeClose'


const ClaimModal = ({
    show,
    onHide,
    poolsdetail,
    winnerData,
    claimvalue,
    sumOfClaimvalue,
    gasEstimateInUsdt,
    gasFeesSpinner,
    canClaim,
    claimcheck,
    getClaims,
    tokenData,
    swapbalance,
    priceoption,
    investedAmount
}) => {
    const { theme } = useTheme()
    const { t } = useTranslation();
    const tokenSymbol = tokenData?.tokenSymbol;
    const winnerOptionId = winnerData?.winnerId;
    const sharesHeld = swapbalance?.[winnerOptionId] || 0;
    const pricePerShare = priceoption?.[winnerOptionId] || 0;
    const winnerOptionIndex = poolsdetail?.options?.findIndex(opt => opt._id === winnerOptionId);
    const winnerDotColor = getBackgroundColor(winnerOptionIndex, theme, poolsdetail?.options?.length);
    const { r, g, b } = hexToRgb(winnerDotColor);

    const handleClaim = () => {
        if (canClaim && poolsdetail?.contractAddress) {
            getClaims(poolsdetail.contractAddress);
            onHide();
        }
    };

    const swipeRef = useSwipeClose(show, onHide);

    return (
        <Modal
            show={show}
            onHide={onHide}
            centered
            className="pollmodal sharesocial-modal new-modal-style claim-modal-style"
            animation={window.innerWidth > 991 ? true : false}
        >
            <Modal.Header ref={swipeRef} onClick={onHide}>
                <div className="close-div"></div>
            </Modal.Header>
            <Modal.Body>
                <div className="parent w-100">
                    <h4>{poolsdetail?.question}</h4>
                    <div className="outcome-box">
                        <p>Final Outcome</p>
                        <h5 style={{ background: `rgba(${r}, ${g}, ${b}, 0.20)`, color: winnerDotColor }}>
                            <span className="dot-color" style={{ backgroundColor: winnerDotColor }}></span>
                            {winnerData?.winnerOption}
                        </h5>
                    </div>
                    <div className="more-option-list">
                        <div className="single-list">
                            <p>Shares Held</p>
                            <h6>{handleToFixedOnDecimals(sharesHeld)}</h6>
                        </div>
                        <div className="single-list">
                            <p>Price Per Share</p>
                            <h6>{getTokenSymbol(tokenSymbol)}{handleToFixedOnDecimals(pricePerShare)}</h6>
                        </div>
                        <div className="single-list">
                            <p>Total Investment</p>
                            <h6>{getTokenSymbol(tokenSymbol)}{formatSmartDecimal(+investedAmount || 0)}</h6>
                        </div>
                        {/* {claimvalue?.shareReward > 0 && (
                            <div className="single-list">
                                <p>Shares Reward</p>
                                <h6>{getTokenSymbol(tokenSymbol)}{formatSmartDecimal(claimvalue.shareReward)}</h6>
                            </div>
                        )} */}
                        <div className="single-list">
                            <p>Network Fee</p>
                            <h6>{gasFeesSpinner ? "..." : `$${handleToFixedOnDecimals(gasEstimateInUsdt)}`}</h6>
                        </div>
                        {/* <div className="single-list total">
                            <p>Total Reward</p>
                            <h6>{getTokenSymbol(tokenSymbol)}{formatSmartDecimal(+sumOfClaimvalue || 0)}</h6>
                        </div> */}
                    </div>
                    <div className="btn-claim">
                        <button
                            onClick={handleClaim}
                            disabled={!canClaim || !gasEstimateInUsdt || gasEstimateInUsdt === 0}
                            className={!canClaim ? 'disabled' : ''}
                        >
                            {claimcheck ? t('Claimed') : t('Claim')}
                        </button>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    )
}

export default ClaimModal
